// Used in Cart if There is No Cart Items
// Used in Favourites is There is No Favourites

import Link from "next/link";
import ImgTag from "./ImgTag";

function Empty({
  img,
  title,
  description,
  shopping,
  fromFav,
  titleClassName = "",
  buttonClassName = "",
  imgClassName = "",
  imgWrapperClassName = "",
  descriptionClassName = "",
}) {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center my-6 bg-white rounded-md">
      <div className={`w-72 ${imgWrapperClassName}`}>
        <ImgTag
          src={img}
          className={`${
            !fromFav ? "h-40 w-40" : "h-[250px] w-[275px]"
          } mx-auto object-contain ${imgClassName}`}
          height={480}
          width={480}
          alt=""
        />
      </div>
      <h4
        className={`mt-10 text-3xl font-semibold text-red max-[570px]:text-xl text-center ${titleClassName}`}
      >
        {title}
      </h4>
      <p className={`my-2 text-center text-zinc-600 ${descriptionClassName}`}>
        {description}
      </p>
      {shopping ? (
        <button
          className={`w-3/12 mx-auto my-[2rem] p-3 rounded-full text-white bg-blue campaign:bg-campaignAccent border-red border duration-200 hover:bg-white hover:text-red campaign:hover:bg-white ${buttonClassName}`}
        >
          <Link href="/">{shopping}</Link>
        </button>
      ) : null}
    </div>
  );
}

export default Empty;
